import React from 'react';
import './index.scss';
import { Helmet } from 'react-helmet';
import { HOME_CANONICAL } from '../../constants/defaults';
import _ from 'lodash';

const Questions = props => {
  let data;
  if (typeof window !== 'undefined' && typeof __INITIAL_DATA__ !== 'undefined')
    data = window.__INITIAL_DATA__;
  else data = props.staticContext.data;

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{data?.metaTitle}</title>
        <link rel="canonical" href={`${HOME_CANONICAL}/questions`} />
        <meta name="description" content={data?.metaDescription} />
      </Helmet>
    );
  };

  const SectionList = ({ title = '', items = [] }) => {
    if (!items?.length) return null;
    return (
      <div
        className={`listSection ${
          title == 'Answers by topic' ? 'answerByTopic' : ''
        }`}
      >
        <h2>{title}</h2>
        <div className="listContainer">
          {items?.map((item, i) => (
            <div className="listItem" key={i}>
              <h3>{item?.blogTitle}</h3>
              <ul>
                {item?.articles?.map((subItem, j) => (
                  <li key={j}>
                    <a href={`/questions/${subItem?.slug}`}>
                      {!_.isEmpty(subItem?.anchorText)
                        ? subItem?.anchorText
                        : subItem?.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <main>
      {getMetaData()}
      <div className="questionsPage">
        <div className="headingMain">
          <div className="headingContainer">
            <h1>{data?.headline}</h1>
            <span>{data?.introText}</span>
          </div>
        </div>
        <div className="questionsContainer">
          {data?.featuredArticles && (
            <div className="faqsContainer">
              <h2>{data?.featuredArticleHeader}</h2>
              <ol>
                {data?.featuredArticles?.map((news, index) => {
                  return (
                    <li key={index}>
                      <a href={`/questions/${news?.slug}`}>
                        {!_.isEmpty(news?.anchorText)
                          ? news?.anchorText
                          : news?.title}
                      </a>
                    </li>
                  );
                })}
              </ol>
            </div>
          )}
          <SectionList
            title={data?.moreResourcesHeader}
            items={data?.answersByDrug}
          />
          <SectionList
            title={data?.heading2}
            items={data?.answersByCondition}
          />
          <SectionList title={data?.heading3} items={data?.answersByTopic} />
        </div>
      </div>
    </main>
  );
};

export default Questions;
